// Unicode Devanagari -> Kruti Dev 010 legacy encoding.
// Kruti Dev 010 places pre-shaped glyphs at ASCII slots, so once converted the string
// can be rendered by jsPDF with the embedded K010 TTF without any shaping engine.

const CONS = "\u0915-\u0939\u0958-\u095F\u0933";
const consCls = `[${CONS}]\u093C?`;
const clusterRe = `(?:${consCls}\u094D)*${consCls}`;
const REPH = "\u0001"; // temp marker for reph

// ordered replacement pairs (multi-char first). Applied after reordering.
const PAIRS = [
  // explicit ligatures
  ["\u0915\u094D\u0937\u094D", "{"], // क्ष्
  ["\u0915\u094D\u0937", "{k"],       // क्ष
  ["\u0936\u094D\u0930", "J"],        // श्र
  ["\u091C\u094D\u091E", "K"],        // ज्ञ
  ["\u0924\u094D\u0930", "\u00AB"],  // त्र
  ["\u0915\u094D\u0930", "\u00D8"],  // क्र
  ["\u0926\u094D\u0927", ")"],        // द्ध
  ["\u0926\u094D\u0935", "}"],        // द्व
  ["\u0926\u094D\u0926", "\u00ED"],  // द्द
  ["\u0926\u094D\u092F", "|"],        // द्य
  ["\u0926\u094D\u092D", "\u00EC"],  // द्भ
  ["\u0926\u094D\u092E", "\u00E2"],  // द्म
  ["\u0939\u0943", "\u00E3"],        // हृ

  // rakar (्र below consonant) — must run before half-consonant splitting
  ["\u094D\u0930", "z"],

  // half consonants (C + halant) — generic drop-k / uppercase forms
  ["\u0915\u094D", "D"], ["\u0916\u094D", "["], ["\u0917\u094D", "X"], ["\u0918\u094D", "?"],
  ["\u0919\u094D", "\u0264"], ["\u091A\u094D", "P"], ["\u091B\u094D", "N\u094D"], ["\u091C\u094D", "T"],
  ["\u091D\u094D", ">"], ["\u091E\u094D", "\u00B4"], ["\u091F\u094D", "V\u094D"], ["\u0920\u094D", "B\u094D"],
  ["\u0921\u094D", "M\u094D"], ["\u0922\u094D", "<\u094D"], ["\u0923\u094D", "."], ["\u0924\u094D", "R"],
  ["\u0925\u094D", "F"], ["\u0926\u094D", "n\u094D"], ["\u0927\u094D", "/"], ["\u0928\u094D", "U"],
  ["\u092A\u094D", "I"], ["\u092B\u094D", "\u00B6"], ["\u092C\u094D", "C"], ["\u092D\u094D", "H"],
  ["\u092E\u094D", "E"], ["\u092F\u094D", "\u00EE"], ["\u0932\u094D", "Y"], ["\u0935\u094D", "O"],
  ["\u0936\u094D", "'"], ["\u0937\u094D", "\""], ["\u0938\u094D", "L"], ["\u0939\u094D", "\u00BA"],
  ["\u0933\u094D", "Y"],
  ["\u0930\u094D", "j\u094D"], // leftover र् (non-reph) fallback

  // nukta consonants
  ["\u0921\u093C", "M+"], ["\u0922\u093C", "<+"], ["\u091C\u093C", "t+"], ["\u092B\u093C", "Q+"],
  ["\u0915\u093C", "d+"], ["\u0916\u093C", "[k+"], ["\u0917\u093C", "x+"], ["\u092F\u093C", ";+"],

  // base consonants
  ["\u0915", "d"], ["\u0916", "[k"], ["\u0917", "x"], ["\u0918", "?k"], ["\u0919", "\u0263"],
  ["\u091A", "p"], ["\u091B", "N"], ["\u091C", "t"], ["\u091D", ">"], ["\u091E", "\u00A5"],
  ["\u091F", "V"], ["\u0920", "B"], ["\u0921", "M"], ["\u0922", "<"], ["\u0923", ".k"],
  ["\u0924", "r"], ["\u0925", "Fk"], ["\u0926", "n"], ["\u0927", "/k"], ["\u0928", "u"],
  ["\u092A", "i"], ["\u092B", "Q"], ["\u092C", "c"], ["\u092D", "Hk"], ["\u092E", "e"],
  ["\u092F", ";"], ["\u0930", "j"], ["\u0932", "y"], ["\u0935", "o"], ["\u0936", "'k"],
  ["\u0937", "\"k"], ["\u0938", "l"], ["\u0939", "g"], ["\u0933", "G"],

  // independent vowels
  ["\u0913", "vks"], ["\u0914", "vkS"], ["\u0906", "vk"], ["\u0905", "v"],
  ["\u0908", "bZ"], ["\u0907", "b"], ["\u090A", "\u00C5"], ["\u0909", "m"],
  ["\u090B", "_"], ["\u090F", ","], ["\u0910", ",s"],

  // matras
  ["\u093E", "k"], ["\u0940", "h"], ["\u0941", "q"], ["\u0942", "w"], ["\u0943", "`"],
  ["\u0947", "s"], ["\u0948", "S"], ["\u094B", "ks"], ["\u094C", "kS"],
  ["\u0902", "a"], ["\u0903", "%"], ["\u0901", "\u00A1"], ["\u093F", "f"],

  // digits & signs
  ["\u0966", "0"], ["\u0967", "1"], ["\u0968", "2"], ["\u0969", "3"], ["\u096A", "4"],
  ["\u096B", "5"], ["\u096C", "6"], ["\u096D", "7"], ["\u096E", "8"], ["\u096F", "9"],
  ["\u0964", "A"], ["\u0965", "AA"], ["\u094D", "\u00A9"], ["\u093C", "+"],
];

function reorderReph(str) {
  const re = new RegExp(`\u0930\u094D(${clusterRe}[\u093E-\u094C]?[\u0902\u0903\u0901]?)`, "g");
  return str.replace(re, `$1${REPH}`);
}

function reorderIMatra(str) {
  const re = new RegExp(`(${clusterRe})\u093F`, "g");
  return str.replace(re, `\u093F$1`);
}

export function unicodeToKrutidev(input) {
  if (input == null) return "";
  let s = String(input);
  if (!s) return "";
  s = s.normalize("NFC");
  s = reorderReph(s);
  s = reorderIMatra(s);
  for (const [u, k] of PAIRS) {
    s = s.split(u).join(k);
  }
  s = s.split(REPH).join("Z");
  return s;
}

export default unicodeToKrutidev;

// Reverse: KrutiDev 010 text (as found in legacy PDFs) -> Unicode Devanagari (best effort).
const REV = [
  ["\u00E7", "\u092A\u094D\u0930"], ["#", "\u0930\u0941"], ["&", "\u2013"], ["]", ","], ["Z", REPH], ["~", "\u094D"],
  [">", "\u091D"], ["=", "\u0924\u094D\u0930"], ["{k", "\u0915\u094D\u0937"],
  ...PAIRS.filter(([, k]) => !k.includes("\u094D") && !/^\d$/.test(k)).map(([u, k]) => [k, u]),
].sort((a, b) => b[0].length - a[0].length);

export function krutidevToUnicode(input) {
  const s = String(input || "");
  let out = "";
  let pendingI = false;
  for (let i = 0; i < s.length; ) {
    if (s[i] === "f") {
      pendingI = true;
      i++;
      continue;
    }
    const hit = REV.find(([k]) => s.startsWith(k, i));
    if (!hit) {
      out += s[i++];
      continue;
    }
    out += hit[1];
    i += hit[0].length;
    if (pendingI && /[\u0915-\u0939\u0933]$/.test(hit[1]) && !/\u094D$/.test(hit[1]) && !s.startsWith("z", i)) {
      out += "\u093F";
      pendingI = false;
    }
  }
  return out
    .replace(new RegExp(`(${clusterRe}[\u093E-\u094C]?[\u0902\u0901]?)${REPH}`, "g"), "\u0930\u094D$1")
    .split(REPH).join("")
    .replace(/\u093E\u0947/g, "\u094B")
    .replace(/\u093E\u0948/g, "\u094C")
    .normalize("NFC");
}
